// @flow

import { beginRequest, completeRequest } from "@store/utils";
import type { AlertSuppressionState } from "./types";

const startRequest = beginRequest(["requestsInProgress"]);

const finishRequest = completeRequest(["requestsInProgress"]);

export const onAddAlertsSuppression = (state: AlertSuppressionState) => () => startRequest(state);
export const onAddAlertsSuppressionError = (state: AlertSuppressionState) => () =>
  finishRequest(state);
export const onDeleteAlertsSuppression = (state: AlertSuppressionState) => () =>
  startRequest(state);
export const onDeleteAlertsSuppressionSuccess = (state: AlertSuppressionState) => () =>
  finishRequest(state);
export const onDeleteAlertsSuppressionError = (state: AlertSuppressionState) => () =>
  finishRequest(state);
export const onGetAlertsSuppressedBy = (state: AlertSuppressionState) => () => startRequest(state);
export const onGetAlertsSuppression = (state: AlertSuppressionState) => () => startRequest(state);

export const onGetAlertsSuppressionOptions = (state: AlertSuppressionState) => () =>
  startRequest(state);

export const onGetAlertsSuppressedBySuccess = (state: AlertSuppressionState) => ({
  payload,
}: *) => {
  return {
    ...state,
    ...finishRequest(state),
    alertsSuppressedBy: payload,
  };
};

export const onGetAlertsSuppressionSuccess = (state: AlertSuppressionState) => ({ payload }: *) => {
  return {
    ...state,
    ...finishRequest(state),
    alertsSuppression: payload,
  };
};
export const onGetAlertsSuppressionError = (state: AlertSuppressionState) => ({ payload }: *) => {
  return {
    ...state,
    ...finishRequest(state),
    alertsSuppression: [],
  };
};
export const onAddAlertsSuppressionSuccess = (state: AlertSuppressionState) => ({ payload }: *) => {
  return {
    ...state,
    ...finishRequest(state),
    alertsSuppression: payload,
  };
};

export const onGetAlertsSuppressionOptionsSuccess = (state: AlertSuppressionState) => ({
  payload,
}: *) => {
  return {
    ...state,
    ...finishRequest(state),
    alertsSuppressionOptions: payload,
  };
};
export const onGetAlertsSuppressionOptionsError = (state: AlertSuppressionState) => ({
  payload,
}: *) => {
  return {
    ...state,
    ...finishRequest(state),
    alertsSuppressionOptions: [],
  };
};
